// extracted by mini-css-extract-plugin
module.exports = {"container":"SummaryRow_container__2WTIV","value-container":"SummaryRow_value-container__2K3vX","value-item":"SummaryRow_value-item__1MC2K"};